import tokeys from 'tokeys';

export const OrderType = tokeys(['voucher', 'digital']);
